import { render, staticRenderFns } from "./PlainText.vue?vue&type=template&id=bc33d4a2&scoped=true&"
import script from "./PlainText.vue?vue&type=script&lang=js&"
export * from "./PlainText.vue?vue&type=script&lang=js&"
import style0 from "./PlainText.vue?vue&type=style&index=0&id=bc33d4a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc33d4a2",
  null
  
)

export default component.exports